import React from 'react';
import {Routes, Route} from 'react-router-dom';
import {Error500Page} from './Error500Page';
import {Error504Page} from './Error504Page';
import {AccessDeniedPage} from './AccessDeniedPage';
import {Error404Page} from './Error404Page';
import UnauthorisedPage from './UnauthorisedPage';

export const ErrorRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/error/500" Component={Error500Page} />
      <Route path="/error/access-denied" Component={AccessDeniedPage} />
      <Route path="/error/unauthorised" Component={UnauthorisedPage} />
      <Route path="/error" Component={Error404Page} />
      <Route path="/login" Component={Error504Page} />
      <Route path="/base" Component={Error504Page} />
      <Route path="/base/login" Component={Error504Page} />
    </Routes>
  );
};
